import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import Dashboard from '../organisms/Dashboard.vue'
import MyExamList from './ExamMyList.vue'
import { headerState } from '../../stores/header'

// Computed

export default /*@__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const schoolSetting = computed(() => headerState.schoolSetting)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (schoolSetting.value && schoolSetting.value.useUserDashboard)
      ? (_openBlock(), _createBlock(Dashboard, { key: 0 }))
      : (_openBlock(), _createBlock(MyExamList, { key: 1 }))
  ]))
}
}

})